import React, { useEffect } from 'react'
import { VERTICAL_TRIPS } from 'AccountsConstants/app'
import PropTypes from 'prop-types'
import { getDuration, flightDuration } from 'AccountsUtils'
import Clock from '../icons/clock.svg'

const Duration = ({ durationData, vertical, isPWA }) => {
  useEffect(() => {
    if (!vertical) {
      throw new Error('vertical must be either air,hotel,activities,fph')
    }
  }, [])
  const airReducer = data => {
    const { arrivalDate, departureDate } = data
    return arrivalDate && departureDate ? getDuration(departureDate, arrivalDate) : null
  }
  const hotelReducer = data => {
    const { checkinDate, checkOutDate } = data
    const first = checkinDate ? new Date(checkinDate) : null
    const last = checkOutDate ? new Date(checkOutDate) : null
    return `${last.getDate() - first.getDate()} night${
      last.getDate() - first.getDate() > 1 ? 's' : ''
    }`
  }
  const verticalMap = {
    air: { icon: <Clock fill="#929292" />, reducer: airReducer },
    hotel: { icon: <Clock fill="#929292" />, reducer: hotelReducer }
  }
  const verticalIconMapper = () => {
    let returnIcon = null
    if (vertical && Object.prototype.hasOwnProperty.call(verticalMap, vertical)) {
      returnIcon = verticalMap[vertical].icon
    }

    return returnIcon
  }
  return (
    <div className={`flex flex-column ${isPWA ? 'flex-center' : ''} ta-center flex-middle px-3`}>
      <If condition={verticalIconMapper()}>{verticalIconMapper()}</If>
      <If condition={durationData}>
        <If condition={vertical !== 'air'}>
          <p className="pt-2">{verticalMap[vertical].reducer(durationData)}</p>
          <Else />
          <p className="pt-2">{flightDuration(durationData.duration)}</p>
        </If>
      </If>
    </div>
  )
}

Duration.defaultProps = {
  durationData: null
}
Duration.propTypes = {
  durationData: PropTypes.string,
  vertical: PropTypes.oneOf(VERTICAL_TRIPS).isRequired
}
export default Duration
